import React from 'react';


function A8Ad() {
    return (
        <div>
            <p>PR: ビジネス英会話を学びませんか?まずは無料体験から (1,200社以上のグローバル企業が語学研修として採用)</p>
            <a href="https://px.a8.net/svt/ejp?a8mat=3TNIF7+2SMBK2+2F62+674EP" rel="nofollow">
                {/* @ts-ignore */}
                <img border="0" width="300" height="250" alt="" src="https://www24.a8.net/svt/bgt?aid=231204355169&wid=003&eno=01&mid=s00000011297001041000&mc=1" />
            </a>
            {/* @ts-ignore */}
            <img border="0" width="1" height="1" src="https://www11.a8.net/0.gif?a8mat=3TNIF7+2SMBK2+2F62+674EP" alt="" />
        </div>
    );
}

export default A8Ad;
